import { useSelector } from 'react-redux';

const Banner = () => {
  const user = useSelector((state) => state.user.details);

  let pageTitle = '';
  if (user) {
    if (user.firstName) {
      pageTitle = 'Welcome ' + user.firstName;
    } else if (user.displayName) {
      pageTitle = 'Welcome ' + user.displayName;
    }
  }

  if (pageTitle === '') {
    return;
  }

  return (
    <div className="page-title bg-black">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 d-flex align-items-center">
            <span className="fi-stack fi-lg hidden-xs">
              <i className="fi fi-circle-solid fi-inverse fi-stack-2x"></i>
              <i className={`fi fi-3people fi-stack-1x`}></i>
            </span>
            {pageTitle && <h1 className="mb-1">{pageTitle}</h1>}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
